import { tariffPlansCurrency } from "../../interface";
import { Currency, PlanPriceProxy } from "@me-team/host/main/graphql/types";

export const currencyOptions: tariffPlansCurrency[] = [
    { value: Currency.Usd, label: "$" },
    { value: Currency.Uah, label: "₴" },
    { value: Currency.Eur, label: "€" },
];

export const currencySymbolMap: Record<Currency, string> = {
    [Currency.Usd]: "$",
    [Currency.Eur]: "€",
    [Currency.Uah]: "₴",
};

export const amountFieldMap = {
    [Currency.Usd]: "usd",
    [Currency.Eur]: "eur",
    [Currency.Uah]: "uah",
} as const satisfies Record<Currency, keyof PlanPriceProxy>;

export const savingsFieldMap = {
    [Currency.Usd]: "savingsUsd",
    [Currency.Eur]: "savingsEur",
    [Currency.Uah]: "savingsUah",
} as const satisfies Record<Currency, keyof PlanPriceProxy>;

export const defaultCurrency = currencyOptions.find((currencyOption) => currencyOption.value === Currency.Usd)!;
